import { getFunctions, httpsCallable } from 'firebase/functions';

class Functions {
  constructor(app) {
    this.instance = getFunctions(app, 'europe-west2');

    this.admin = {
      getBuild: this.createFn('admin-getBuild'),
      sendVerificationEmail: this.createFn('admin-sendVerificationEmail'),
      createVerificationRequest: this.createFn(
        'admin-createVerificationRequest'
      ),
    };

    this.plaid = {
      createPaymentRecipient: this.createFn('plaid-createPaymentRecipient'),
      createAISLink: this.createFn('plaid-createAISLink'),
      exchangeAISToken: this.createFn('plaid-exchangeAISToken'),
      createPISLink: this.createFn('plaid-createPISLink'),
      exchangePISToken: this.createFn('plaid-exchangePISToken'),
      createLinkToken: this.createFn('plaid-createLinkToken'),
    };

    this.property = {
      searchQuery: this.createFn('property-searchQuery'),
      lookupAddressFromPostcode: this.createFn(
        'postcode-lookupAddressFromPostcode'
      ),
    };

    this.tenancy = {
      terminateTenancy: this.createFn('tenancy-terminateTenancy'),
      sendMessage: this.createFn('tenancy-sendMessage'),
      createEngagement: this.createFn('tenancy-createEngagement'),
      beginTenancy: this.createFn('tenancy-beginTenancy'),
      linkTenants: this.createFn('tenancy-linkTenants'),
      manualPayment: this.createFn('tenancy-manualPayment'),
      sendPaymentReminder: this.createFn('tenancy-sendPaymentReminder'),
      linkToATenancy: this.createFn('tenancy-linkToATenancy'),
    };

    this.authentication = {
      sendAuthenticationEmail: this.createFn(
        'authentication-sendAuthenticationEmail'
      ),
      verifyEmailAuthentication: this.createFn(
        'authentication-verifyEmailAuthentication'
      ),
    };

    this.deposit = {
      register: this.createFn('deposit-register'),
      getDepositCertificateUrl: this.createFn(
        'deposit-getDepositCertificateUrl'
      ),
    };

    this.epc = {
      getEPCData: this.createFn('epc-getEPCData'),
    };

    this.agreement = {
      createAndSend: this.createFn('agreement-createAndSend'),
    };

    this.stripe = {
      checkoutUrl: this.createFn('stripe-checkoutUrl'),
      billingPortalUrl: this.createFn('stripe-billingPortalUrl'),
    };
  }

  createFn(name) {
    return httpsCallable(this.instance, name);
  }

  destroy() {
    this.instance = null;
    this.admin = null;
    this.plaid = null;
    this.property = null;
    this.tenancy = null;
  }
}

export default Functions;
